import React from 'react';
import { Columns, Column } from 'src/ui/mui-ui-kit';
import { Field } from 'react-final-form';
import propTypes from 'prop-types';
import { cleanseInt } from 'src/ui/util';
import { UiInputAdapter, UiFieldset } from 'src/ui';
import { composeValidators, required } from 'src/ui/validations';
import { PHONE_MASK } from 'src/ui/const';

export function BankForm({ form }) {
  return (
    <>
      <UiFieldset title="Settlement & Fee Account" isFirst>
        <Columns isMultiline>
          <Column isSize="1/2">
            <Field
              component={UiInputAdapter}
              name="accountBankName"
              id="accountBankName"
              required
              label="Bank Name"
              validate={composeValidators('Bank Name', required)}
            />
          </Column>
          <Column isSize="1/2">
            <Field
              component={UiInputAdapter}
              name="accountNameOnAccount"
              id="accountNameOnAccount"
              required
              label="Name on Account"
              validate={composeValidators('Name on Account', required)}
            />
          </Column>
          <Column isSize="1/2">
            <Field
              component={UiInputAdapter}
              name="accountBankAddress"
              id="accountBankAddress"
              required
              label="Bank Address"
              validate={composeValidators('Bank Address', required)}
            />
          </Column>
          <Column isSize="1/2">
            <Field
              component={UiInputAdapter}
              name="accountRoutingNumber"
              id="accountRoutingNumber"
              required
              label="Routing Number"
              validate={composeValidators('Routing Number', required)}
              onChange={e => form.mutators.cleanse(e, cleanseInt)}
            />
          </Column>
          <Column isSize="1/2">
            <Field
              component={UiInputAdapter}
              name="accountAccountNumber"
              id="accountAccountNumber"
              required
              label="Account Number"
              validate={composeValidators('Account Number', required)}
              onChange={e => form.mutators.cleanse(e, cleanseInt)}
            />
          </Column>
          <Column isSize="1/2">
            <Field
              component={UiInputAdapter}
              id="accountBankPhoneNumber"
              name="accountBankPhoneNumber"
              label="Bank Phone Number"
              required
              mask={PHONE_MASK}
              validate={composeValidators('Phone', required)}
            />
          </Column>
        </Columns>
      </UiFieldset>
    </>
  );
}

BankForm.propTypes = {
  form: propTypes.object.isRequired,
};
